<div class="modal-panel-tarefa">
  <div class="modal-header">
    <div class="modal-header-left">
      <div class="modal-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" />
          <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4z" />
        </svg>
      </div>
      <div>
        <h2 class="modal-title">Editar tarefa</h2>
        <p class="modal-subtitle">Altere os campos da tarefa e salve as mudanças</p>
      </div>
    </div>
    <button class="btn-close" type="button" (click)="fechar.emit()">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    </button>
  </div>

  <div class="modal-body">
    <div class="info-empresa" *ngIf="empresaNome">
      <span class="info-label">Empresa</span>
      <span class="info-valor">{{ empresaNome }}</span>
    </div>

    <div class="form-group">
      <label class="form-label">Contato</label>
      <div class="chips">
        <span *ngIf="contatoNome" class="chip">{{ contatoNome }}</span>
        <span *ngIf="!contatoNome" class="hint">Nenhum contato vinculado</span>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group">
        <label class="form-label" for="responsavel">
          Responsável
          <span class="required">*</span>
        </label>
        <select
          id="responsavel"
          class="form-select"
          [class.form-input--error]="erro && !responsibleID"
          [(ngModel)]="responsibleID"
        >
          <option value="" disabled>Selecione</option>
          <option *ngFor="let r of responsaveis" [value]="r.id">{{ r.name }}</option>
        </select>
        <span class="error-msg" *ngIf="erro && !responsibleID">Selecione</span>
      </div>

      <div class="form-group">
        <label class="form-label" for="tarefa">
          Tipo de tarefa
          <span class="required">*</span>
        </label>
        <select
          id="tarefa"
          class="form-select"
          [class.form-input--error]="erro && !actionID"
          [(ngModel)]="actionID"
        >
          <option value="" disabled>Selecione</option>
          <option *ngFor="let a of acoes" [value]="a.actionId">{{ a.description }}</option>
        </select>
        <span class="error-msg" *ngIf="erro && !actionID">Selecione</span>
      </div>
    </div>

    <div class="form-row form-row--data">
      <div class="form-group">
        <label class="form-label" for="data">
          Data
          <span class="required">*</span>
        </label>
        <input
          id="data"
          type="date"
          class="form-input"
          [class.form-input--error]="erro && !data"
          [(ngModel)]="data"
        />
        <span class="error-msg" *ngIf="erro && !data">Informe a data</span>
      </div>

      <div class="form-group">
        <label class="form-label" for="hora">
          Hora
          <span class="required">*</span>
        </label>
        <input
          id="hora"
          type="time"
          class="form-input"
          [class.form-input--error]="erro && !hora"
          [(ngModel)]="hora"
        />
        <span class="error-msg" *ngIf="erro && !hora">Informe a hora</span>
      </div>
    </div>

    <div class="form-group">
      <label class="form-label" for="descricao">Descreva a tarefa</label>
      <textarea
        id="descricao"
        class="form-textarea"
        rows="4"
        maxlength="2000"
        [(ngModel)]="description"
        placeholder="Adicione informações sobre a tarefa..."
      ></textarea>
      <div class="textarea-footer">
        <span class="char-count">{{ description.length }}/2000</span>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn-secondary" type="button" (click)="fechar.emit()">Cancelar</button>
    <button class="btn-primary" type="button" (click)="editar()" [disabled]="carregando">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z" />
        <polyline points="17 21 17 13 7 13 7 21" />
        <polyline points="7 3 7 8 15 8" />
      </svg>
      {{ carregando ? 'Aguarde...' : 'Salvar alterações' }}
    </button>
  </div>
</div>
